import React from "react";
import { FileText, Edit2, Trash2 } from "lucide-react";
import { Button } from "../ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";

export const TemplatesTab = ({ templates, setIsAddTemplateOpen, openTemplateEditor, deleteTemplate }) => (
  <div className="space-y-6" data-testid="admin-templates-tab">
    <div className="flex justify-between items-center">
      <div>
        <h2 className="text-2xl font-bold text-gray-900">Template Management</h2>
        <p className="text-gray-600">Manage task templates for efficient workflow</p>
      </div>
      <Button onClick={() => setIsAddTemplateOpen(true)} className="flex items-center gap-2 bg-orange-600 hover:bg-orange-700" data-testid="add-template-btn">
        <FileText className="h-4 w-4" /> Add New Template
      </Button>
    </div>

    <Card className="border-0 shadow-lg bg-gradient-to-br from-orange-50 to-orange-100">
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-orange-900">Total Templates</CardTitle>
        <FileText className="h-4 w-4 text-orange-600" />
      </CardHeader>
      <CardContent><div className="text-3xl font-bold text-orange-900">{templates.length}</div></CardContent>
    </Card>

    <Card className="border-0 shadow-lg">
      <CardHeader className="bg-gray-50 rounded-t-lg"><CardTitle className="text-gray-900">All Templates</CardTitle></CardHeader>
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="text-left p-4 font-semibold text-gray-700">Template Name</th>
                <th className="text-left p-4 font-semibold text-gray-700">Type</th>
                <th className="text-left p-4 font-semibold text-gray-700">Tasks Count</th>
                <th className="text-left p-4 font-semibold text-gray-700">Actions</th>
              </tr>
            </thead>
            <tbody>
              {templates.map((template, index) => (
                <tr key={template.id} className={`border-b hover:bg-gray-50 ${index % 2 === 0 ? 'bg-white' : 'bg-gray-25'}`} data-testid={`template-row-${template.id}`}>
                  <td className="p-4 font-medium text-gray-900">{template.name}</td>
                  <td className="p-4"><Badge variant="outline" className="bg-orange-100 text-orange-800">{template.template_type.replace('_', ' ')}</Badge></td>
                  <td className="p-4 text-gray-600">{template.tasks?.length || 0} tasks</td>
                  <td className="p-4">
                    <div className="flex gap-2">
                      <Button size="sm" variant="outline" onClick={() => openTemplateEditor(template)} className="hover:bg-orange-50" data-testid={`edit-template-${template.id}`}>
                        <Edit2 className="h-3 w-3" />
                      </Button>
                      <Button size="sm" variant="outline" onClick={() => deleteTemplate(template.id)} className="text-red-600 hover:text-red-700 hover:bg-red-50" data-testid={`delete-template-${template.id}`}>
                        <Trash2 className="h-3 w-3" />
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  </div>
);
